import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './state/store'
import axios from 'axios'
window.API = axios;

Vue.config.productionTip = false

import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue);

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import VueSlimScroll from 'vue-slimscroll'
Vue.use(VueSlimScroll)

import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

import fontawesome from '@fortawesome/fontawesome'
import fasolid from '@fortawesome/fontawesome-free-solid';

import VRPay from './plugins/vue-vrpay'

Vue.use(VRPay, {testMode: true})

import Snotify, { SnotifyPosition } from 'vue-snotify'

const options = {
    toast: {
        position: SnotifyPosition.rightTop
    }
}

Vue.use(Snotify, options)

import {API, EventBus} from './lib/api'

EventBus.$on('api:response:api-unauthorized-response', () => {
  store.dispatch('auth/logout')
  if(router.currentRoute.name != 'login') {
    router.push('/login')
  }
})

Vue.use(require('vue-moment'));

Vue.config.api = process.env

Vue.globalEventBus = new Vue();

window.wpwlOptions = {
    locale: "de",
    brandDetection: true,
    style: "plain",
    showCVVHint: true,
    labels: {
      cvv: 'Kartenprüfnummer (CVV)',
      submit: 'Jetzt bezahlen und verbindlich buchen'
    },
    onReady: () => {
    //  Vue.globalEventBus.$emit('payframe-ready')
    },
    onReadyIframeCommunication: () => {
      Vue.globalEventBus.$emit('payframe-ready')
    }
}

Vue.filter('stringifyNumber', function (value, decimalSeparator = ',', fixed = null) {
  if(!value) value = 0
  let numberString
  if(fixed !== null) {
     numberString = value.toFixed(fixed)
  }else {
     numberString = value.toString()
  }
  return numberString.replace('.', decimalSeparator)
})

;(async function () {
  await store.dispatch('auth/VALIDATE')
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
})();



// WEBPACK FOOTER //
// ./src/main.js